import type { ApiService } from '@widgets/shared/services/apiService'
import sentryMonitoringService from '@widgets/shared/services/monitoring/sentryMonitoringService'

export const registerSentryInterceptor = (apiService: ApiService) => {
  apiService.registerResponseErrorInterceptor((error) => {
    // Don't log canceled requests — normal flow (often on mobile/background)
    if (apiService.isCancel(error)) {
      return Promise.reject(error)
    }
    try {
      sentryMonitoringService.handleAxiosError(error)
    } catch {
      // Don't let the monitoring break the propagation of the original error
    }
    return Promise.reject(error)
  })
}
